var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCaution(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6673 14.0002C25.6673 7.55684 20.444 2.3335 14.0007 2.3335C7.55733 2.3335 2.33398 7.55684 2.33398 14.0002C2.33398 20.4435 7.55733 25.6669 14.0007 25.6669C20.444 25.6669 25.6673 20.4435 25.6673 14.0002Z",
    fill: "#FFC738"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8201 7.5835H13.1817C13.023 7.58324 12.866 7.61178 12.7203 7.66733C12.5746 7.72288 12.4432 7.80428 12.3344 7.90651C12.2255 8.00874 12.1414 8.12964 12.0873 8.26175C12.0332 8.39386 12.0102 8.5344 12.0197 8.67469L12.531 16.3335H15.4592L15.9822 8.67469C15.9917 8.5344 15.9686 8.39386 15.9145 8.26175C15.8604 8.12964 15.7763 8.00874 15.6675 7.90651C15.5586 7.80428 15.4273 7.72288 15.2815 7.66733C15.1358 7.61178 14.9788 7.58324 14.8201 7.5835Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 21.4204C14.9665 21.4204 15.75 20.6369 15.75 19.6704C15.75 18.7039 14.9665 17.9204 14 17.9204C13.0335 17.9204 12.25 18.7039 12.25 19.6704C12.25 20.6369 13.0335 21.4204 14 21.4204Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCaution);
export default __webpack_public_path__ + "static/media/icon_caution.6f835a8640027a9b144bc82e085995c3.svg";
export { ForwardRef as ReactComponent };